var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.98 14.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252529;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.57,14.98c-.39-.11-.57-.38-.68-.76-.58-2.06-1.17-4.12-1.76-6.18-.03-.11-.09-.17-.2-.2-2.07-.59-4.14-1.18-6.21-1.76-.37-.1-.63-.3-.73-.67v-.32c.12-.38.4-.55.76-.67C5.13,2.97,9.5,1.52,13.87.06c.33-.11.63-.07.88.18.25.25.29.55.18.88-1.48,4.42-2.95,8.85-4.42,13.27-.11.32-.32.51-.64.6h-.29ZM13.28,1.13s0-.01-.01-.02C9.13,2.49,4.99,3.87.82,5.26c.07.02.1.04.14.05,2.07.59,4.15,1.18,6.22,1.78.11.03.16-.01.22-.08,1.92-1.93,3.85-3.85,5.77-5.78.03-.03.07-.07.1-.1Zm-3.57,12.99s.02,0,.03,0c1.38-4.14,2.76-8.28,4.14-12.41-.01,0-.03-.02-.04-.03-.03.04-.06.09-.1.13-1.92,1.92-3.83,3.84-5.75,5.75-.09.09-.11.17-.08.29.5,1.74,1,3.47,1.49,5.21.1.35.2.71.31,1.06Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmeter);
export default __webpack_public_path__ + "static/media/submeter.c1fe2ca18bc6d8a26fcb7aab0c79b1c9.svg";
export { ForwardRef as ReactComponent };